$(function () {
  var pre_ref = document.referrer;
  const LP_EX_URL = "https://geek-salon.com/webex";
  const addExMessage =
    "===WebExpertコースの紹介ページを見て申し込みました。(このメッセージは自動で記述されています)===";

  if (LP_EX_URL == pre_ref) {
    document.getElementById("landing_page_entry_memo").textContent =
      addExMessage;
  }

  if ($("form .landing_page_entry_area_id").length < 1) return;
  $(".form-input-box input, .form-input-box select").each(function () {
    updateInputBox(this, false);
  });
  $(".form-input-box input, .form-input-box select").on("input", function () {
    updateInputBox(this, true);
  });
  let events = [];
  $("select#landing_page_entry_event_period_id option").each(function (
    i,
    trial
  ) {
    events.push(trial);
  });
  let $area =
    $(
      "select[name='landing_page_user_trial[area_id]'] option:selected"
    ).val() || "";
  let $course =
    $(
      "select[name='landing_page_user_trial[course_id]'] option:selected"
    ).val() || "";
  updateEvents();

  $("select[name='landing_page_entry[area_id]']").on("change", function () {
    $area = this.value;
    updateEvents();
  });

  $("select[name='landing_page_entry[course_id]']").on("change", function () {
    $course = this.value;
    updateEvents();
  });

  $("select[name='landing_page_entry[payment]']").on("change", function () {
    $payment = this.value;
    $(".payment_caution").hide();
    if ($payment == "credit") {
      $("#credit_caution").show();
    } else if ($payment == "cash") {
      $("#cash_caution").show();
    }
  });

  $("select[name='landing_page_entry[from_where]']").on("change", function () {
    $fromWhere = this.value;
    if ($fromWhere.includes("紹介")) {
      $(".form-block.introducer").show();
    } else {
      $(".form-block.introducer").hide();
    }
  });

  $(".scroll-commercial").scroll(function () {
    let scrollHeight = $(".scroll-commercial").get(0).scrollHeight;
    let scrollPosition =
      $(".scroll-commercial").height() + $(".scroll-commercial").scrollTop();
    if ((scrollHeight - scrollPosition) / scrollHeight < 0.1) {
      $('input[name="landing_page_entry[agreement_cancel]"]').removeAttr(
        "disabled"
      );
      $('input[name="landing_page_entry[agreement_course]"]').removeAttr(
        "disabled"
      );
      $('input[name="landing_page_entry[agreement_mail]"]').removeAttr(
        "disabled"
      );
      $(".require-reading-commercial").hide();
    }
  });

  $(".scroll-terms").scroll(function () {
    let scrollHeight = $(".scroll-terms").get(0).scrollHeight;
    let scrollPosition =
      $(".scroll-terms").height() + $(".scroll-terms").scrollTop();
    if ((scrollHeight - scrollPosition) / scrollHeight < 0.03) {
      $('input[name="landing_page_entry[agreement_terms]"]').removeAttr(
        "disabled"
      );
      $(".require-reading-terms").hide();
    }
  });

  //入会フォームの同意チェックボックス
  $(".agreement").each(function () {
    let agreement = $(this);
    let input = agreement.find("input[type='checkbox']");
    let label = agreement.find("label");
    input.on("change", function () {
      if (input.prop("checked")) {
        agreement.addClass("success");
        agreement.find(".error-message").remove();
      } else {
        agreement.removeClass("success");
        if (agreement.find(".error-message").length == 0) {
          agreement.prepend(
            "<div class='error-message'>同意してください</div>"
          );
        }
      }
      checkRequiredInputs();
    });
  });

  $("input[type='checkbox'][name='landing_page_entry[agreement_terms]']").on(
    "change",
    function () {
      if (
        $(
          ".agreement.a_terms input[type='checkbox'][name='landing_page_entry[agreement_terms]']"
        ).prop("checked")
      ) {
        $(".agreement.a_terms").addClass("success");
        $(".agreement.a_terms").find(".error-message").remove();
      } else {
        $(".agreement.a_terms").removeClass("success");
        if ($(".agreement.a_terms").find(".error-message").length == 0) {
          $(".agreement.a_terms").prepend(
            "<div class='error-message'>同意してください</div>"
          );
        }
      }
      checkRequiredInputs();
    }
  );

  function updateEvents() {
    $("select#landing_page_entry_event_period_id option").remove();
    for (let i = 0; i < events.length; i++) {
      let $event = $(events[i]);
      if (
        ($event.data("area-id") == $area.toString() &&
          $event.data("course-id") == $course.toString()) ||
        $event.val() == ""
      ) {
        $("select#landing_page_entry_event_period_id").append($event);
      }
    }
    $("#landing_page_entry_event_period_id").val("");
    updateInputBox($("select#anding_page_entry_event_period_id"), true);
  }

  function updateInputBox($input, loadError) {
    $inputBox = $($input).parents(".form-input-box");
    if ($input.value == "") {
      $inputBox.removeClass("has-input");
    } else {
      $inputBox.addClass("has-input");
    }
    if (!$inputBox.hasClass("valid")) {
      return;
    }

    if ($inputBox.hasClass("valid-blank")) {
      success = $input.value;
      let blockTitle = $inputBox
        .parents(".form-block")
        .find(".block-title")
        .text();
      errorMessage = `${blockTitle}を入力してください`;
    }
    if ($inputBox.hasClass("valid-select")) {
      success = $input.value;
      let blockTitle = $inputBox
        .parents(".form-block")
        .find(".block-title")
        .text();
      errorMessage = `${blockTitle}を選択してください`;
    }
    if ($inputBox.hasClass("valid-email")) {
      success = $input.value.includes("@");
      errorMessage = "メールアドレスが正しくありません";
    }
    if ($inputBox.hasClass("valid-phone")) {
      success = $input.value.match(/^0([5789]0\d{8}|[1-9]{2}\d{7})$/);
      errorMessage = "電話番号が正しくありません";
    }

    $inputBox.removeClass("success");
    $inputBox.removeClass("error");
    $inputBox.find(".error-message").remove();
    if (success) {
      $inputBox.addClass("success");
    } else if (loadError) {
      $inputBox.addClass("error");
      $inputBox.append(`<div class='error-message'>${errorMessage}</div>`);
    }
    checkRequiredInputs();
  }

  function checkRequiredInputs() {
    let validationCount = $(".valid").length;
    let successCount = $(".success").length;
    if (validationCount == successCount && $(".event_period select").val()) {
      $("input[type='submit']").prop("disabled", false);
      $(".disabled-submit-message").hide();
      $("#entry-submit").click(() => {
        $(".loading ").addClass("active");
        $(".loading-message").text(
          "処理には時間がかかる場合がございます。しばらくお待ちください。"
        );
      });
    } else {
      $("input[type='submit']").prop("disabled", true);
      $(".disabled-submit-message").show();
    }
  }
});
